<template>
  <a
    :class="classes"
    :href="phoneNumberTel"
    @click="gtmPhoneCallTrigger($event, gtmLabel)"
    v-html="ctaText || phoneNumber"
  />
</template>

<script>
import { sprintf } from 'sprintf-js';
import { usePhoneNumber } from 'Main/composables/usePhoneNumber';

export default {
  name: 'PhoneNumberCta',

  setup() {
    const {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    } = usePhoneNumber();
    return {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    };
  },

  data() {
    const { classes, text, showNumberInText, gtmLabel, overrideHiddenNumber } =
      this.$mountEl.dataset;
    return {
      classes,
      text,
      showNumberInText,
      gtmLabel,
      overrideHiddenNumber: overrideHiddenNumber === 'true',
    };
  },

  mounted() {
    if (this.hidePhoneNumber && !this.overrideHiddenNumber) {
      this.updatePhoneNumber(null);
    } else if (!this.isTherapyPage) {
      window.addEventListener(
        'city-storage-updated-event',
        this.maybeUpdatePhoneNumber
      );
      this.maybeUpdatePhoneNumber();
    }
  },

  beforeUnmount() {
    window.removeEventListener(
      'city-storage-updated-event',
      this.maybeUpdatePhoneNumber
    );
  },

  computed: {
    ctaText() {
      if (this.showNumberInText) {
        return sprintf(this.text, this.phoneNumber);
      }

      return this.text;
    },
  },
};
</script>
